import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  data: function data() {
    return {
      searchForm: {
        type: 1
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      config: {},
      // 表单
      form: {},
      dialogVisible: false // 弹窗状态
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getBootScreenConfig();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    // 开放 | 关闭
    updateBootScreenStatus: function updateBootScreenStatus(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this2.$confirm("确认操作， 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var res;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this2.$api.updateBootScreenStatus({
                        id: row.id,
                        status: row.status == 1 ? 2 : 1,
                        type: _this2.searchForm.type
                      });
                    case 1:
                      res = _context2.v;
                      _this2.$message.success("操作成功");
                      _this2.getData();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    addDialog: function addDialog() {
      this.dialogVisible = true;
      this.form = {
        type: this.searchForm.type,
        url: "",
        fullScreenUrl: "",
        linkType: 0,
        link: ""
      };
    },
    getBootScreenConfig: function getBootScreenConfig() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$api.getBootScreenConfig();
            case 1:
              res = _context4.v;
              _this3.searchForm.type = res.data.type;
              _this3.config = res.data;
              _this3.getData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateBootScreenConfig: function updateBootScreenConfig() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this4.$api.updateBootScreenConfig(_this4.config);
            case 1:
              _this4.$message.success("操作成功");
              _this4.getBootScreenConfig();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getData: function getData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this5.tableLoading = true;
              _context6.n = 1;
              return _this5.$api.getBootScreenList(_this5.searchForm);
            case 1:
              res = _context6.v;
              _this5.tableData = res.data;
              _this5.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!_this6.form.id) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return _this6.$api.updateBootScreen(_this6.form);
            case 1:
              _context7.n = 3;
              break;
            case 2:
              _context7.n = 3;
              return _this6.$api.addBootScreen(_this6.form);
            case 3:
              _this6.dialogVisible = false;
              _this6.form = {};
              _this6.getData();
            case 4:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this7 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this7.$api.deleteBootScreen({
                id: row.id
              });
            case 1:
              _this7.$message.success("操作成功");
              _this7.getData();
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))).catch(function () {});
    }
  }
};